import * as XLSX from "xlsx";
import { message } from "antd";

const exportExcel = ({ data, fileName, sheetName, errorMessage, successMessage }) => {
    if (!data || !data?.length) {
        message?.error(errorMessage || "No data available to export")
        return;
    }

    try {
        const worksheet = XLSX.utils.json_to_sheet(data);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, (sheetName || "Sheet 1"));

        const safeFileName = (fileName || "table-export").replace(/[\\/:*?"<>|]+/g, '');
        XLSX.writeFile(workbook, `${safeFileName}.xlsx`);

        message?.success(successMessage || "Excel generated successfully");
    } catch (err) {
        message?.error("Failed to generate Excel file");
    }
}

export default exportExcel